export const materials = {
  soneva: {
    colors: {
      sand: 'sand',
      creamWhite: 'creamWhite',
      gray: 'gray',
      anthracite: 'anthracite',
      saharaBrown: 'saharaBrown',
    },
    dimensionsInCm: {
      normalBrick: {
        width: 39,
        height: 16,
        depth: 19.5,
      },
      halfBrick: {
        width: 19.5,
        height: 16,
        depth: 19.5,
      },
      topCover: {
        width: 46,
        height: 6,
        depth: 26.5,
      },
    },
  },
};

export const elementNames = {
  column: 'Oszlop',
  fundament: 'Lábazat',
  door: 'Kapu',
};

export const colorNames = {
  sand: 'Homokkő',
  creamWhite: 'Krémfehér',
  gray: 'Szürke',
  anthracite: 'Antracit',
  saharaBrown: 'Szahara barna',
};

export const currentBrick = materials.soneva.dimensionsInCm;
export const cmToPxRatio = 1;
export const slatHeightInCm = 12;
export const slatPercentOfRail = 70;
